<template>
  <WidgetBaseCard v-bind="$props" v-on="$listeners">
    <template #title>
      <slot name="title"></slot>
    </template>

    <template #content>
      <v-spacer></v-spacer>

      <div class="pa-4">
        <div class="d-flex justify-center mt-3">
          <slot name="main"></slot>
        </div>

        <div class="d-flex justify-space-between mt-3">
          <slot name="subs"></slot>
        </div>
      </div>
    </template>
  </WidgetBaseCard>
</template>
<script>
import WidgetBaseCard from "./WidgetBaseCard.vue";

export default {
  components: { WidgetBaseCard },

  props: {
    error: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    lastUpdate: {
      type: Date,
      default: null
    }
  }
};
</script>
